<div class="content">
	<br>
	<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/error.png"
		[attr.x-contenttype]="'image/png'" style="max-width: 25%;">

	<h1>There seems to have been an error!</h1>

	<div>
		<table>
			<tr>
				<th style="width: 200px;">Client ID: </th>
				<td>{{client_id}}</td>
			</tr>
			<tr>
				<th>Connection: </th>
				<td>{{connection}}</td>
			</tr>
			<tr>
				<th>Lang: </th>
				<td>{{lang}}</td>
			</tr>
			<tr>
				<th>Error: </th>
				<td>{{error}}</td>
			</tr>
			<tr>
				<th>Error Description: </th>
				<td>{{error_description}}</td>
			</tr>
			<tr>
				<th>Tracking: </th>
				<td>{{tracking}}</td>
			</tr>
		</table>
	</div>

	<br>
	<!-- *ngIf="(auth.isAuthenticated$ | async) === true" -->
	<!-- If not logged in display a log in button -->
	<div class="center">
		<p>Try Logging out</p>
		<button mat-flat-button id="qsLoginBtn" color="primary" (click)="logout()">
			<mat-icon>lock</mat-icon>&nbsp;Log out</button>
	</div>
</div>
